import { render, staticRenderFns } from "./edit-banner.vue?vue&type=template&id=0f744fc4&scoped=true"
import script from "./edit-banner.vue?vue&type=script&lang=js"
export * from "./edit-banner.vue?vue&type=script&lang=js"
import style0 from "./edit-banner.vue?vue&type=style&index=0&id=0f744fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f744fc4",
  null
  
)

export default component.exports